import { Directive, ElementRef, inject, OnDestroy, OnInit } from '@angular/core';
import { Table } from 'primeng/table';
import { Subscription } from 'rxjs';

@Directive({
  selector: 'p-table[letKeepScrollPosition]',

  host: {
    '(onRowSelect)': 'onRowSelect()',
  }
})
export class KeepScrollPositionDirective implements OnInit, OnDestroy {
  visibilityObserver!: IntersectionObserver;
  valueSubscription!: Subscription;
  private table!: Table;
  private el: ElementRef<Element> = inject(ElementRef);
  private scrollPosition = 0;

  constructor(private host: Table) {
    this.table = host;
  }

  resetScrollPosition() {
    this.scrollPosition = 0;
  }

  onRowSelect() {
    this.saveScrollPosition();
  }

  saveScrollPosition() {
    const tbl = this.el.nativeElement.querySelector('.p-datatable-table-container');
    if (tbl) {
      this.scrollPosition = tbl.scrollTop;
    }
  }

  restoreScrollPosition() {
    setTimeout(() => {
      const tbl = this.el.nativeElement.querySelector('.p-datatable-table-container');
      if (tbl) {
        tbl?.scrollTo({ top: this.scrollPosition });
      }
    }, 1);
  }

  ngOnInit(): void {
    //Used to trigger when table becomes visible, so we can restore the scroll position
    this.visibilityObserver = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting) {
          this.restoreScrollPosition();
        }
      });
    });
    this.visibilityObserver.observe(this.el.nativeElement);

    //Used to reset scroll position, when data changes
    this.valueSubscription = this.table.tableService.valueSource$.subscribe(() => {
      this.resetScrollPosition();
    });

  }

  ngOnDestroy(): void {
    this.visibilityObserver.disconnect();
    this.valueSubscription.unsubscribe();
  }
}
